import { Icon, Button } from 'antd';
import { Link } from 'react-router-dom';
import { ssFormUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { login as config } from '../forms/formConfig';

const 
{ key } = config,
{ setEnvPrefix } = ssCommonUtils,
{ generateInitState } = ssFormUtils;

export default class Pending extends React.Component {
    constructor(props) { super(props); }
    render() {
        const 
        { services, state: { registrationForm, login: { loginButtonDisabled, showLoginStatusModal }}} = this.props,
        form = registrationForm[key];
        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'Account has expired.'}
                    </span>
                    <div style={{ marginTop: '20px' }}>
                        <div style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                            {'Please update your password.'}
                        </div>
                        <div>
                            <Link to={setEnvPrefix('/home/passwordexpirationreset')}>
                                <Button
                                    icon='link'
                                    type='primary'
                                    style={{ fontSize: '14px', width: '200px', borderRadius: '8px', marginTop: '7px' }}
                                    onClick={() => {
                                        services.toggleAfspLoginModal();
                                        services.resetAfspLoginRequest();
                                        if (showLoginStatusModal) services.toggleAfspLoginStatusModal();
                                        if (!loginButtonDisabled) services.toggleAfspLoginButtonDisable();
                                        if(!form) services.storeForm(key, generateInitState(config));
                                    }}
                                >
                                    {'Update Password'}
                                </Button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}